Ext.define('SA.CrosstabDataCache', {
    constructor({location, refreshHandler}) {
        this.refreshHandler = refreshHandler;

        this.cache = new Map();
        this.proxy = new SA.CrosstabDataProxy({location, onResults: this.onProxyResults.bind(this)});
    },

    cacheResults(results) {
        results.forEach(result => {
            var {id, data} = result,
                data = Object.freeze(data);

            this.cache.set(id, data);
        });
    },

    get(id) {
        var loading = !this.cache.has(id),
            data = this.cache.get(id) || null,
            empty = !loading && data === null;

        return {loading, empty, data};
    },

    hasData() {
        return this.cache.size > 0;
    },

    onProxyResults(results) {
        this.cacheResults(results);

        this.refreshHandler();
    },

    request(attributes) {
        attributes.filterIds(Array.from(this.cache.keys()));

        if (attributes.isEmpty()) {
            return;
        }

        this.proxy.request(attributes);
    }
});